import React from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';

const ProtectedRoute = ({ children, requiredPermission, requiredPermissions, requireAll = false }) => {
  const { isAuthenticated, loading, hasPermission, user } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0A2463] to-[#1E3A8A] flex items-center justify-center">
        <div className="text-center text-white">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#FFD700] mx-auto mb-4"></div>
          <p className="text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0A2463] to-[#1E3A8A] flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">🔒</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Authentication Required</h2>
            <p className="text-gray-600 mb-6">Please log in to access this page.</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-[#0A2463] text-white px-6 py-2 rounded-lg hover:bg-[#1E3A8A] transition"
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Check permissions if required
  if (requiredPermission || requiredPermissions) {
    let hasAccess = false;

    if (requiredPermission) {
      hasAccess = hasPermission(requiredPermission);
    } else if (requiredPermissions && Array.isArray(requiredPermissions)) {
      if (requireAll) {
        hasAccess = requiredPermissions.every(perm => hasPermission(perm));
      } else {
        hasAccess = requiredPermissions.some(perm => hasPermission(perm));
      }
    }

    if (!hasAccess) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-[#0A2463] to-[#1E3A8A] flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
            <div className="text-center">
              <div className="text-yellow-500 text-6xl mb-4">⚠️</div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h2>
              <p className="text-gray-600 mb-4">
                You don't have permission to access this page.
              </p>
              <p className="text-sm text-gray-500 mb-6">
                Required permission: {requiredPermission || requiredPermissions?.join(' or ')}
              </p>
              <button
                onClick={() => window.history.back()}
                className="bg-[#0A2463] text-white px-6 py-2 rounded-lg hover:bg-[#1E3A8A] transition"
              >
                Go Back
              </button>
            </div>
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;

